import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { QbPaymentMethod } from '@/types/settings';

/**
 * Fetch QBO PaymentMethods. The backend falls back to a hardcoded list
 * (Cash, Check, Credit Card, Bank Transfer) if the QB API is unavailable
 * so the UI always renders something useful.
 */
export function useQbPaymentMethods() {
  return useApiQuery<QbPaymentMethod[]>({
    queryKey: settingsKeys.qbPaymentMethods(),
    queryFn: () =>
      apiGet<QbPaymentMethod[]>(operationsClient, settingsEndpoints.qbPaymentMethods()),
    showErrorToast: false,
    staleTime: 10 * 60 * 1000,
  });
}
